import { IDocumentParameterDefinition, ISymbol } from "@kuika/kuika-cl-model";

/**
 * When a document parameter counts as bound (KOA-17254).
 *
 * Shared rather than duplicated because two surfaces report it — the table marks each unbound row, and the entry
 * card on a Document component's properties summarises how many are bound. An unbound parameter is precisely why a
 * document renders with its `<TAG>` showing, so the two must never disagree about which ones those are.
 *
 * A symbol is bound when it names a source action's returned field, or a declared document input on its own. Both
 * halves of the action case are required: an action with no field selected resolves to nothing.
 */
export const isDocumentParameterBound = (symbol: ISymbol | undefined): boolean =>
  !!symbol && ((!!symbol.actionDefinitionId && !!symbol.fieldName) || !!symbol.inputName);

/** How many of these definitions would actually resolve to a value. */
export const countBoundDocumentParameters = (definitions: IDocumentParameterDefinition[]): number =>
  definitions.filter((definition: IDocumentParameterDefinition) =>
    isDocumentParameterBound(definition.symbol as ISymbol | undefined)
  ).length;
